import { config } from 'circulator/hooks/config';
import type * as api from 'common/types/api';
import { Api } from 'common/utils/api';
import { useQuery } from 'react-query';

type Response = api.GetPrimaryAttendeeResponse;

export function useGetPrimaryAttendee(procedureId: number | undefined) {
    const { key, path } = config.attendee.primary(procedureId);

    const result = useQuery(key, () => Api.get<Response>({ path }), {
        enabled: Boolean(procedureId),
        refetchInterval: 4000,
    });

    return {
        primaryAttendee: result.data,
        isLoading: result.isLoading,
        isFetching: result.isFetching,
    };
}
